module.exports = __webpack_public_path__ + "fonts/InformaPro.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/InformaPro.ttf
// module id = 32
// module chunks = 0